import React, { useState } from 'react';
import CountrySelect from './CountrySelect';

const DocumentForm = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    citizenship: [],
    destination: '',
    duration: '',
    purpose: '',
    embassy: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (formData.citizenship.length === 0) {
      alert('Please select at least one citizenship');
      return;
    }
    if (!formData.destination) {
      alert('Please select a destination country');
      return;
    }
    if (!formData.duration || !formData.purpose || !formData.embassy) {
      alert('Please fill in all required fields');
      return;
    }
    
    onSubmit(formData);
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <>
      <p className="subtitle">Get your visa documents ready in minutes</p>
      
      <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Your Citizenship(s)</label>
            <CountrySelect
              value={formData.citizenship}
              onChange={(value) => handleChange('citizenship', value)}
              placeholder="Select citizenship(s)"
              multiple={true}
            />
          </div>

          <div className="form-group">
            <label>Destination Country</label>
            <CountrySelect
              value={formData.destination}
              onChange={(value) => handleChange('destination', value)}
              placeholder="Select destination country"
              multiple={false}
            />
          </div>

          <div className="form-group">
            <label>Duration of Stay</label>
            <select
              value={formData.duration}
              onChange={(e) => handleChange('duration', e.target.value)}
              required
            >
              <option value="">Select duration</option>
              <option value="Less than 90 days">Less than 90 days</option>
              <option value="3-6 months">3-6 months</option>
              <option value="6-12 months">6-12 months</option>
              <option value="More than 1 year">More than 1 year</option>
              <option value="Permanent">Permanent residence</option>
            </select>
          </div>

          <div className="form-group">
            <label>Purpose of Travel</label>
            <select
              value={formData.purpose}
              onChange={(e) => handleChange('purpose', e.target.value)}
              required
            >
              <option value="">Select purpose</option>
              <option value="Tourism">Tourism</option>
              <option value="Business">Business</option>
              <option value="Study">Study</option>
              <option value="Work">Work</option>
              <option value="Medical">Medical Treatment</option>
              <option value="Family">Family Visit</option>
              <option value="Conference">Conference/Event</option>
            </select>
          </div>

          <div className="form-group">
            <label>Place of Application</label>
            <input
              type="text"
              placeholder="e.g., New York Consulate"
              value={formData.embassy}
              onChange={(e) => handleChange('embassy', e.target.value)}
              required
            />
          </div>

        <button type="submit" className="btn btn-primary">
          Generate Document Checklist
        </button>
      </form>
    </>
  );
};

export default DocumentForm;